import * as React from "react";
const SvgFiRrBarberPole = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18 18V6a1 1 0 0 0 0-2h-.35c-.826-2.327-3.043-4-5.65-4S7.176 1.673 6.35 4H6a1 1 0 0 0 0 2v12a1 1 0 0 0 0 2h.35c.826 2.327 3.043 4 5.65 4s4.824-1.673 5.65-4H18a1 1 0 0 0 0-2m-4.086 0L8 12.086V9.414l8 8V18zM10.086 6 16 11.914v2.672l-8-8V6zM16 9.086 12.914 6H16zM12 2c1.474 0 2.75.81 3.444 2H8.557c.694-1.19 1.97-2 3.444-2zM8 14.914 11.086 18H8zM12 22c-1.474 0-2.75-.81-3.444-2h6.887c-.694 1.19-1.97 2-3.444 2z"
    />
  </svg>
);
export default SvgFiRrBarberPole;
